import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import type { HaNFloorSuggestions, HaNSelection } from "@lib/logic";

import { HaNResultList } from "../HaNResultList/HaNResultList";
import type { HaNResult } from "../useOpenResult";
import { FloorSuggestionGroup } from "./components/FloorSuggestionGroup";

type FloorSuggestionsProps<Item extends HaNResult> = {
  kind: HaNSelection["kind"];
  suggestions: HaNFloorSuggestions<Item>;
  renderCell: (item: Item) => ReactNode;
};

/** What's available on the floors above and below, for when the selected floor has little. Each item opens on its floor. */
export const FloorSuggestions = <Item extends HaNResult>({
  kind,
  suggestions,
  renderCell,
}: FloorSuggestionsProps<Item>) => {
  const { t } = useTranslation();

  if (!suggestions.above && !suggestions.below) return null;

  return (
    <>
      <HaNResultList.Header title={t("hereAndNow:SuggestionsOnOtherFloors")} />

      <div className="flex flex-col gap-2 px-3 py-2">
        {suggestions.above && (
          <FloorSuggestionGroup
            kind={kind}
            suggestion={suggestions.above}
            direction="above"
            renderCell={renderCell}
          />
        )}

        {suggestions.below && (
          <FloorSuggestionGroup
            kind={kind}
            suggestion={suggestions.below}
            direction="below"
            renderCell={renderCell}
          />
        )}
      </div>
    </>
  );
};
